import {HoodItem} from "./SeatingPlanModel";
import {NeighbourhoodListFilterForm, neighbourhoodSortOptions} from "../neighbourhood-list/NeighbourhoodListFilter";
import {
    calculateStatRanges,
    calculateVisitWithAssignedDesksStatistics,
    emptyStatRanges,
    StatRanges,
    VisitWithAssignedDesksStats
} from "../../components/visit-stat-block/OfficeVisitStats";
import {assignedDeskCriteria} from "../../components/visit-stat-block/AssignedDeskCriteria";
import {AssignedDesks} from "../../api/AssignedDeskStore";
import {EmployeeVisitSheet} from "../../api/EmployeeVisitStore";
import {applyFilter, filterText} from "../../util/FilterUtil";

const neighbourhoodStatsComparators: Record<keyof typeof neighbourhoodSortOptions, (a: HoodItem & {
    stats: VisitWithAssignedDesksStats
}, b: HoodItem & { stats: VisitWithAssignedDesksStats }) => number> = {
    overflowDays: (a, b) => b.stats.overflowDays - a.stats.overflowDays,
    maxDays: (a, b) => b.stats.maxVisits.percent - a.stats.maxVisits.percent,
    percentile90: (a, b) => b.stats.percentile90.percent - a.stats.percentile90.percent,
    medianDays: (a, b) => b.stats.median.percent - a.stats.median.percent,
    averageDays: (a, b) => b.stats.avgVisits.percent - a.stats.avgVisits.percent,
    name: (a, b) => a.name.localeCompare(b.name),
    recommendedAssignedDeskCount: (a, b) => b.stats.employeeStats.assignedDeskRecommendationEmployees.size - a.stats.employeeStats.assignedDeskRecommendationEmployees.size,
};


export function filterHoodItems(
    employeeVisits: EmployeeVisitSheet,
    assignedDesks: AssignedDesks,
    rows: HoodItem[],
    filter: NeighbourhoodListFilterForm,
): {
    filteredHoods: (HoodItem & { stats: VisitWithAssignedDesksStats })[],
    statRanges: StatRanges,
} {
    if (rows.length === 0) {
        return {filteredHoods: [], statRanges: emptyStatRanges};
    }

    const rowsWithStats = rows
        .map(hood => ({
            ...hood,
            stats: calculateVisitWithAssignedDesksStatistics(
                employeeVisits,
                hood.newEmployees,
                assignedDesks,
                assignedDeskCriteria[filter.assignedDeskCriteria],
                filter.dateRange,
                hood.newDesks.length,
            ),
        }));


    const filtered = applyFilter(
        rowsWithStats,
        filterText(filter.search, hoodItem => [
            hoodItem.name,
            hoodItem.notes,
            hoodItem.displayColor,
            ...hoodItem.newEmployees.map(employee => employee.fullName),
        ])
    );

    return {
        filteredHoods: filtered.sort(neighbourhoodStatsComparators[filter.sortedBy]),
        statRanges: calculateStatRanges(
            rowsWithStats
                .filter(hood => hood.newEmployees.length > 0)
                .map(hood => hood.stats)
        ),
    };
}
